export default __webpack_public_path__ + "static/media/skirmishers_war_glaive.ecbbbc05.jpg";